import React, { createRef, useState, useEffect } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import ReactTooltip from "react-tooltip";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Card, Descriptions, Space, Tag, Skeleton, Button, Drawer, Table, Input, DatePicker, Dropdown, Tooltip, Collapse, Modal, Popconfirm, QRCode, Popover } from "antd";
import Select from "react-select";
import dayjs from "dayjs";
import { faChevronDown, faEdit, faEye, faList, faPlus, faPrint, faSave, faTrash, faUndo } from "@fortawesome/free-solid-svg-icons";

function Invoicing(props) {
  let { invoice_tag } = useParams();
  let { state } = useLocation();
  const location = useLocation();
  let navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [invoice, setInvoice] = useState({ line_items: [], time_entries: [], adjustment_codes: [] });
  const [timeEntries, setTimeEntries] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [invoiceDrawerOpen, setInvoiceDrawerOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [items, setItems] = useState([]);
  const [adjustmentCodes, setAdjustmentCodes] = useState([]);
  const [users, setUsers] = useState([]);

  const [selectedLineItem, setSelectedLineItem] = useState({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
  const [addLineItemModalOpen, setAddLineItemModalOpen] = useState(false);
  const addLineItemFocusFirst = createRef();
  const [selectedAdjustment, setSelectedAdjustment] = useState({
    adjustment: null,
    adjustment_codes_xref: null,
    discount: 1,
    user: null,
    adjustment_by: null,
    item: null,
    items_xref: null,
    description: "",
    rate: 0,
    quantity: 1,
    total: 0,
  });
  const [addAdjustmentModalOpen, setAddAdjustmentModalOpen] = useState(false);
  const addAdjustmentCodeFocusFirst = createRef();
  const [modalWidth, setModalWidth] = useState(1200);

  const GetInvoice = async () => {
    if (invoice_tag) {
      let request = await props.AxiosRequest("/api/invoices/get/full", { tag: invoice_tag });
      setInvoice(request.data.invoice);
    }
  };
  const GetInvoices = async () => {
    let request = await props.AxiosRequest("/api/invoices/get/by-client", { client_id: client?.id });
    setInvoices(request.data.invoices);
  };
  const GetClient = async () => {
    let request = await props.AxiosRequest("/api/clients/get", { cid: invoice?.clients_xref });
    setClient(request.data.client);
  };
  const GetTimeEntries = async () => {
    let invoice_time_entries = { data: { time_entries: [] } };
    if (invoice?.id) invoice_time_entries = await props.AxiosRequest("/api/time-entries/get", { invoices_xref: invoice?.id });
    let unbilled_time_entries = await props.AxiosRequest("/api/time-entries/get", { clients_xref: client?.id, billable: 1, final_state: 0, invoices_xref_is_null: true });
    let time_entries = [
      ...invoice_time_entries.data.time_entries.map((m) => {
        return { ...m, key: m.id };
      }),
      ...unbilled_time_entries.data.time_entries.map((m) => {
        return { ...m, key: m.id };
      }),
    ];
    setTimeEntries(time_entries);
    setSelectedRowKeys(time_entries.filter((f) => f.invoices_xref).map((m) => m.key));
  };
  const SaveInvoice = async () => {
    if (invoice?.status !== 1) return FinalizeInvoice();
    await props.AxiosRequest("/api/invoices/update", { ...invoice, status: 1 });
  };
  const FinalizeInvoice = async () => {
    await props.AxiosRequest("/api/invoices/update", { ...invoice, status: 2 });
    GetInvoice();
  };
  const ResetInvoiceToProposed = async () => {
    await props.AxiosRequest("/api/invoices/propose", { ...invoice });
    GetInvoice();
  };
  const DeleteInvoice = async () => {
    await props.AxiosRequest("/api/invoices/delete", { ...invoice });
    navigate("/invoices");
  };
  const OnSelectTimeEntryChange = async (newSelectedRowKeys) => {
    setInvoice({ ...invoice, time_entries: timeEntries.filter((f) => newSelectedRowKeys.includes(f.id)) });
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const OnSelectAllTimeEntries = async () => {
    setInvoice({ ...invoice, time_entries: timeEntries });
    setSelectedRowKeys(timeEntries.map((m) => m.id));
  };
  const OnDeselectAllTimeEntries = async () => {
    setInvoice({ ...invoice, time_entries: [] });
    setSelectedRowKeys([]);
  };
  const UpdateOutOfBalanceFigure = async () => {
    let time_entry_total = 0,
      line_item_total = 0,
      adjustments_total = 0;

    if (timeEntries?.length > 0) time_entry_total = props.FormatNumberTwoDecimals(timeEntries.filter((f) => selectedRowKeys.includes(f.id)).reduce((a, b) => a + b.hours * b.bill_rate, 0));
    if (invoice?.line_items?.length > 0) line_item_total = props.FormatNumberTwoDecimals(invoice?.line_items.reduce((a, b) => a + b.total, 0));
    if (invoice?.adjustment_codes?.length > 0) adjustments_total = props.FormatNumberTwoDecimals(invoice?.adjustment_codes.reduce((a, b) => a + b.total, 0));
    setInvoice({ ...invoice, out_of_balance_figure: time_entry_total * -1.0 + (line_item_total - adjustments_total), time_entry_total, line_item_total, adjustments_total });
  };

  const GetItems = async () => {
    let request = await props.AxiosRequest("/api/items/get");
    setItems(
      request.data.items.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetUsers = async () => {
    let request = await props.AxiosRequest("/api/users/get");
    setUsers(
      request.data.users.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetAdjustmentCodes = async () => {
    let request = await props.AxiosRequest("/api/adjustment-codes/get");
    setAdjustmentCodes(
      request.data.adjustment_codes.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };

  const invoices_columns = [
    {
      title: "Invoice Number",
      dataIndex: "name",
      key: "name",
      render: (value, object) => (
        <Link
          to={"/invoicing/" + object.tag}
          onClick={() => {
            setInvoiceDrawerOpen(false);
          }}
        >
          <Tag>#{value}</Tag>
        </Link>
      ),
      sorter: (a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0),
      defaultSortOrder: "desc",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (text == 1 ? <Tag color="#108ee9">Proposed</Tag> : <Tag color="#87d068">Finalized</Tag>),
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Amount",
      dataIndex: "total",
      key: "total",
      render: (text) => props.FormatNumberToCurrency(text),
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Invoiced At",
      dataIndex: "invoiced_at",
      key: "invoiced_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.invoiced_at.toUpperCase() < b.invoiced_at.toUpperCase() ? -1 : a.invoiced_at.toUpperCase() > b.invoiced_at.toUpperCase() ? 1 : 0),
    },
    {
      title: "Due At",
      dataIndex: "due_at",
      key: "due_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.due_at.toUpperCase() < b.due_at.toUpperCase() ? -1 : a.due_at.toUpperCase() > b.due_at.toUpperCase() ? 1 : 0),
    },
  ];
  const time_entries_columns = [
    {
      title: "Date",
      dataIndex: "time_at",
      key: "time_at",
      render: (value) => props.MakeDateTimeReadable(value),
      sorter: (a, b) =>
        dayjs(a.time_at).format("YYYYMMDDHHmmss").toUpperCase() < dayjs(b.time_at).format("YYYYMMDDHHmmss").toUpperCase()
          ? -1
          : dayjs(a.time_at).format("YYYYMMDDHHmmss").toUpperCase() > dayjs(b.time_at).format("YYYYMMDDHHmmss").toUpperCase()
          ? 1
          : 0,
      defaultSortOrder: "desc",
    },
    {
      title: "User",
      dataIndex: "users_name",
      key: "users_name",
    },
    {
      title: "Job",
      dataIndex: "jobs_name",
      key: "jobs_name",
    },
    {
      title: "Task",
      dataIndex: "tasks_name",
      key: "tasks_name",
    },
    {
      title: "Task Status",
      dataIndex: "task_statuses_name",
      key: "task_statuses_name",
    },
    {
      title: "Item",
      dataIndex: "items_name",
      key: "items_name",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (value) => <Input.TextArea value={value ? value : ""} rows={1} style={{ resize: "both" }}></Input.TextArea>,
    },
    {
      title: "Hours",
      dataIndex: "hours",
      key: "hours",
      align: "right",
      render: (value) => props.FormatNumberTwoDecimals(value),
    },
    {
      align: "right",
      title: "Bill Rate",
      dataIndex: "bill_rate",
      key: "bill_rate",
      render: (value) => props.FormatNumberToCurrency(value),
    },
    {
      align: "right",
      title: "Extended Rate",
      dataIndex: "hours",
      key: "extended_rate",
      render: (value, object) => props.FormatNumberToCurrency(object.hours * object.bill_rate),
    },
  ];
  const line_items_columns = [
    {
      title: "Item",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (value) => props.FormatNumberToCurrency(value),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (value) => value,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (value) => props.FormatNumberToCurrency(value),
    },
    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (value, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              let found_line_item = invoice.line_items.find((f) => (f.id ? f.id === value : f.key === row.key));
              let found_item = items.find((f) => f.id === found_line_item.items_xref);
              setSelectedLineItem({ ...found_line_item, item: found_item, updating: true });
              setAddLineItemModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>

          <Popconfirm
            title="Are you sure?"
            description="Are you sure you want to delete this line item?"
            onConfirm={() => {
              setInvoice({ ...invoice, line_items: invoice.line_items.filter((f) => f.key !== row.key) });
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button size="small" danger onClick={() => {}}>
              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const adjustment_codes_columns = [
    {
      title: "Adjustment Code",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Item",
      dataIndex: "items_name",
      key: "items_name",
    },
    {
      title: "User",
      dataIndex: "users_name",
      key: "users_name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (value) => props.FormatNumberToCurrency(value),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (value) => value,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (value) => props.FormatNumberToCurrency(value),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "right",
      key: "id",
      render: (value, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              let found_adjustment_code = invoice.adjustment_codes.find((f) => (f.id ? f.id === value : f.key === row.key));
              let found_item = items.find((f) => f.id === found_adjustment_code.items_xref);
              let found_adjustment = adjustmentCodes.find((f) => f.id === found_adjustment_code.adjustment_codes_xref);
              let found_user = users.find((f) => f.id === found_adjustment_code.adjustment_by);
              setSelectedAdjustment({ ...found_adjustment_code, item: found_item, adjustment: found_adjustment, user: found_user, updating: true });
              setAddAdjustmentModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Popconfirm
            title="Are you sure?"
            description="Are you sure you want to delete this adjustment?"
            onConfirm={() => {
              setInvoice({ ...invoice, adjustment_codes: invoice.adjustment_codes.filter((f) => f.key !== row.key) });
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button size="small" danger onClick={() => {}}>
              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const save_menu_items = [
    {
      label:
        invoice?.status === 2 && invoice?.out_of_balance_figure !== 0 ? (
          <Tooltip title="This invoice has already been finalized, so it must be in balance to save it.">
            <div>
              <FontAwesomeIcon icon={faSave} className="mr-1" />
              Save
            </div>
          </Tooltip>
        ) : (
          <div onClick={SaveInvoice}>
            <FontAwesomeIcon icon={faSave} className="mr-1" />
            Save
          </div>
        ),
      key: "0",
      disabled: invoice?.status === 2 && invoice?.out_of_balance_figure !== 0,
    },
    {
      label:
        invoice?.out_of_balance_figure !== 0 ? (
          <Tooltip title="This invoice is not in balance, so it cannot be finalized.">
            <div>
              <FontAwesomeIcon icon={faSave} className="mr-1" />
              Save and Finalize
            </div>
          </Tooltip>
        ) : (
          <div onClick={FinalizeInvoice}>
            <FontAwesomeIcon icon={faSave} className="mr-1" />
            Save and Finalize
          </div>
        ),
      key: "1",
      disabled: invoice?.out_of_balance_figure !== 0,
    },
  ];
  const rowSelection = {
    selectedRowKeys,
    onChange: OnSelectTimeEntryChange,
  };
  useEffect(() => {
    GetInvoice();
    GetItems();
    GetUsers();
    GetAdjustmentCodes();
  }, [location]);
  useEffect(() => {
    if ((!client && invoice?.clients_xref) || invoice?.clients_xref !== client?.id) GetClient();
  }, [invoice?.clients_xref]);
  useEffect(() => {
    if (client?.id && invoice?.id) GetTimeEntries();
    if (client?.id && state?.client_id) GetTimeEntries();
  }, [invoice?.id, client?.id, location]);
  useEffect(() => {
    if (invoices.length === 0) GetInvoices();
  }, [client?.id]);
  useEffect(() => {
    UpdateOutOfBalanceFigure();
  }, [timeEntries, invoice.line_items, invoice.adjustment_codes, invoice.time_entries]);

  return (
    <main className="content">
      <div className="container-fluid">
        <Row gutter={[16, 16]}>
          <Col span={4}>
            <div className="header">
              <h1 className="header-title">Invoicing</h1>
            </div>
          </Col>
          <Col span={20}>
            <Card
              style={{
                width: "100%",
              }}
            >
              <Row gutter={[16, 16]}>
                <Col span={18}>
                  {client ? (
                    <Descriptions title={client?.name || <Skeleton.Button active />}>
                      <Descriptions.Item label="Name">
                        <Link to={"/client-details/" + client.tag}>{client.name}</Link>
                      </Descriptions.Item>
                      <Descriptions.Item label="Address">{client.address}</Descriptions.Item>
                      <Descriptions.Item label="Home / Office Phone">{client.office_phone}</Descriptions.Item>
                      <Descriptions.Item label="Client Categories">
                        <Space size={[0, 8]} wrap>
                          {client.client_categories.map((m, i) => (
                            <Tag key={"tag-" + i}>{m.name}</Tag>
                          ))}
                        </Space>
                      </Descriptions.Item>
                      <Descriptions.Item label="Additional Details">{client.additional_details}</Descriptions.Item>
                    </Descriptions>
                  ) : (
                    <Skeleton active />
                  )}
                </Col>
                <Col span={6} className="text-right">
                  <Button
                    onClick={() => {
                      setInvoiceDrawerOpen(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} className="mr-2" /> View Previous Invoices
                  </Button>
                  <Drawer
                    title={client?.name ? "Previous Invoices For " + client.name : "Previous Invoices"}
                    placement={"right"}
                    width={"35vw"}
                    onClose={() => {
                      setInvoiceDrawerOpen(false);
                    }}
                    open={invoiceDrawerOpen}
                  >
                    <Table columns={invoices_columns} dataSource={invoices}></Table>
                  </Drawer>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Invoice Details">
              {invoice ? (
                <>
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <Row gutter={[16, 16]}>
                        <Col span={10}>
                          <label className="col-form-label-sm">Invoice Number</label>
                          <Input type="text" style={{ textAlign: "center" }} value={invoice?.name ? "#" + invoice?.name : "Not yet saved"} className="form-control" readOnly />
                        </Col>
                        <Col span={10}>
                          <label className="col-form-label-sm">Out of Balance Figure</label>
                          <Tooltip
                            title={
                              <>
                                Time Entry Total - Line Items Total - Adjustments Total = Out of Balance Figure
                                <br />
                                {props.FormatNumberToCurrency(invoice.time_entry_total)} - {props.FormatNumberToCurrency(invoice.line_item_total)} -{" "}
                                {props.FormatNumberToCurrency(invoice.adjustments_total)} = {props.FormatNumberToCurrency(invoice.out_of_balance_figure)}
                              </>
                            }
                          >
                            <Input
                              type="text"
                              style={
                                invoice?.out_of_balance_figure
                                  ? invoice?.out_of_balance_figure === 0
                                    ? { textAlign: "center", backgroundColor: "#86BA90" }
                                    : { textAlign: "center", backgroundColor: "#E44E58" }
                                  : {}
                              }
                              value={props.FormatNumberToCurrency(invoice?.out_of_balance_figure)}
                              className="form-control"
                              readOnly
                            />
                          </Tooltip>
                        </Col>
                        <Col span={4}>
                          <label className="col-form-label-sm">Invoice Status</label>
                          <br />
                          {invoice?.status === 1 ? <Tag color="#108ee9">Proposed</Tag> : null}
                          {invoice?.status === 2 ? <Tag color="#87d068">Finalized</Tag> : null}
                          {invoice?.status === undefined ? <Tag className="bg-warning">Not Yet Saved</Tag> : null}
                        </Col>
                        <Col span={10}>
                          <label className="col-form-label-sm">Invoice Date</label>
                          <DatePicker
                            className="form-control"
                            format={"MM/DD/YYYY"}
                            type="text"
                            value={invoice?.invoiced_at ? dayjs(invoice?.invoiced_at) : null}
                            onChange={(e) => {
                              setInvoice({ ...invoice, invoiced_at: e });
                            }}
                            style={{ textAlign: "center" }}
                          />
                        </Col>
                        <Col span={10}>
                          <label className="col-form-label-sm">Due At</label>
                          <DatePicker
                            format={"MM/DD/YYYY"}
                            className="form-control"
                            type="text"
                            value={invoice?.due_at ? dayjs(invoice?.due_at) : null}
                            onChange={(e) => {
                              setInvoice({ ...invoice, due_at: e });
                            }}
                            style={{ textAlign: "center" }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <label className="col-form-label-sm">&nbsp;</label>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <Dropdown
                            menu={{
                              items: save_menu_items,
                            }}
                            trigger={["click"]}
                          >
                            <Button type="primary" className="w-100">
                              <FontAwesomeIcon icon={faSave} className="mr-1" />
                              Save
                              <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                            </Button>
                          </Dropdown>
                        </Col>
                        <Col span={12}>
                          <Dropdown
                            menu={{
                              items: [
                                {
                                  label: (
                                    <Link
                                      style={{ textDecoration: "none" }}
                                      to={{
                                        pathname: "/invoice-preview/" + invoice_tag,
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPrint} className="mr-1" />
                                      Print Preview Invoice
                                    </Link>
                                  ),
                                  key: "0",
                                },
                                {
                                  label: (
                                    <Link style={{ textDecoration: "none" }} to={"/invoice-preview-with-details/" + invoice_tag}>
                                      <FontAwesomeIcon icon={faList} className="mr-1" />
                                      Print Preview Invoice &amp; Details
                                    </Link>
                                  ),
                                  key: "1",
                                },
                              ],
                            }}
                            trigger={["click"]}
                          >
                            <Button className="w-100">
                              <FontAwesomeIcon icon={faPrint} className="mr-1" />
                              Print Preview
                              <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                            </Button>
                          </Dropdown>
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          {invoice.time_entries.length > 0 ? (
                            <Button danger className="w-100" disabled={true}>
                              <FontAwesomeIcon icon={faTrash} className="mr-1" />
                              Delete Invoice
                            </Button>
                          ) : (
                            <Popconfirm
                              title="Are you sure?"
                              description="Are you sure you want to delete this invoice?"
                              onConfirm={() => {
                                DeleteInvoice();
                              }}
                            >
                              <Button danger className="w-100">
                                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                                Delete Invoice
                              </Button>
                            </Popconfirm>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Collapse
                        size="small"
                        ghost
                        expandIcon={() => <></>}
                        items={[
                          {
                            key: "1",
                            label: (
                              <Row className="text-center">
                                <Col span={24}>
                                  <Button size="small" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                                    View More Details
                                  </Button>
                                </Col>
                              </Row>
                            ),
                            children: (
                              <Row gutter={[16, 16]}>
                                <Col span={6}>
                                  <label className="col-form-label-sm">Exported At</label>
                                  <DatePicker
                                    format={"MM/DD/YYYY"}
                                    style={{ textAlign: "center" }}
                                    value={invoice?.exported_at ? dayjs(invoice?.exported_at) : null}
                                    className="form-control"
                                    disabled
                                    placeholder="Not Yet Exported"
                                  />
                                </Col>
                                <Col span={6}>
                                  <label className="col-form-label-sm">Export Batch</label>
                                  <Input type="text" style={{ textAlign: "center" }} value={invoice?.export_batches_xref ? invoice?.export_batches_xref : "N/A"} className="form-control" readOnly />
                                </Col>
                                <Col span={6}>
                                  <label className="col-form-label-sm">Emailed At</label>
                                  <DatePicker
                                    format={"MM/DD/YYYY"}
                                    style={{ textAlign: "center" }}
                                    value={invoice?.emailed_at ? dayjs(invoice?.emailed_at) : null}
                                    className="form-control"
                                    disabled
                                    placeholder="Not Yet Emailed"
                                  />
                                </Col>
                                <Col span={6}>
                                  <label className="col-form-label-sm">Emailed To</label>
                                  <Input type="text" style={{ textAlign: "center" }} value={invoice?.emailed_to ? invoice?.emailed_to : "N/A"} className="form-control" readOnly />
                                </Col>
                                <Col span={12}>
                                  <label className="col-form-label-sm">Payment Link</label>
                                  <Input
                                    type="text"
                                    onClick={() => {
                                      if (navigator?.clipboard) {
                                        navigator.clipboard.writeText(
                                          window.location.protocol +
                                            "//" +
                                            window.location.hostname +
                                            (window.location.port === "3000" ? ":3000" : "") +
                                            "/portal/payments-direct/c/" +
                                            client?.tag +
                                            "/i/" +
                                            invoice?.tag,
                                        );
                                        props.MakeNotification("success", "Link Copied to your clipboard");
                                      }
                                    }}
                                    style={{ textAlign: "center" }}
                                    value={
                                      invoice?.tag && client?.tag
                                        ? window.location.protocol +
                                          "//" +
                                          window.location.hostname +
                                          (window.location.port === "3000" ? ":3000" : "") +
                                          "/portal/payments-direct/c/" +
                                          client?.tag +
                                          "/i/" +
                                          invoice?.tag
                                        : "N/A"
                                    }
                                    className="form-control"
                                    readOnly
                                  />
                                </Col>
                                <Col span={6}>
                                  <label className="col-form-label-sm">QR Code to Invoice</label>
                                  <Popover
                                    content={
                                      invoice?.tag && client?.tag ? (
                                        <QRCode
                                          errorLevel="M"
                                          value={
                                            window.location.protocol +
                                            "//" +
                                            window.location.hostname +
                                            (window.location.port === "3000" ? ":3000" : "") +
                                            "/portal/payments-direct/c/" +
                                            client?.tag +
                                            "/i/" +
                                            invoice?.tag
                                          }
                                          // icon="/assets/img/brands/reggie-edited.png"
                                        />
                                      ) : (
                                        "Error Loading QR Code"
                                      )
                                    }
                                  >
                                    <Button className="w-100">View QR Code</Button>
                                  </Popover>
                                </Col>
                                <Col span={6}>
                                  <label className="col-form-label-sm">&nbsp;</label>
                                  <Button
                                    className="w-100"
                                    onClick={() => {
                                      ResetInvoiceToProposed();
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faUndo} className="mr-1" />
                                    Reset Invoice to Proposed State
                                  </Button>
                                </Col>
                              </Row>
                            ),
                          },
                        ]}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <Skeleton />
              )}
            </Card>
          </Col>
          <Col span={24}>
            <Card
              title="Unbilled Time Entries"
              extra={
                rowSelection.selectedRowKeys.length === timeEntries.length ? (
                  <Button size="small" onClick={OnDeselectAllTimeEntries}>
                    Deselect All Time Entries
                  </Button>
                ) : (
                  <Button onClick={OnSelectAllTimeEntries} size="small">
                    Select All Time Entries
                  </Button>
                )
              }
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Table
                    rowSelection={rowSelection}
                    columns={time_entries_columns}
                    scroll={{ x: 10 }}
                    pagination={false}
                    dataSource={timeEntries}
                    summary={(pageData) => {
                      let hours_total = 0;
                      let rate_total = 0;
                      let selected_hours_total = 0;
                      let selected_rate_total = 0;
                      pageData.forEach((row) => {
                        hours_total += row?.hours;
                        rate_total += row?.bill_rate * row?.hours;
                        if (selectedRowKeys.includes(row?.id)) {
                          selected_hours_total += row?.hours;
                          selected_rate_total += row?.bill_rate * row?.hours;
                        }
                      });
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell>Selected:</Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell className="text-right" index={8}>
                              {props.FormatNumberTwoDecimals(selected_hours_total)}
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell className="text-right" index={10}>
                              {props.FormatNumberToCurrency(selected_rate_total)}
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                          <Table.Summary.Row>
                            <Table.Summary.Cell>Total:</Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell className="text-right" index={8}>
                              {props.FormatNumberTwoDecimals(hours_total)}
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell className="text-right" index={10}>
                              {props.FormatNumberToCurrency(rate_total)}
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  />
                </Col>
              </Row>
            </Card>
            <Card
              title="Line Items"
              extra={
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      setAddLineItemModalOpen(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Add A Line Item
                  </Button>
                </>
              }
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Table
                    columns={line_items_columns}
                    scroll={{ x: 10 }}
                    dataSource={invoice?.line_items}
                    pagination={false}
                    summary={(pageData) => {
                      let rate_total = 0;
                      pageData.forEach(({ total }) => {
                        rate_total += total;
                      });
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell>Total:</Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell>{props.FormatNumberToCurrency(rate_total)}</Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  ></Table>
                </Col>
              </Row>
            </Card>
            <Card
              title="Adjustments"
              extra={
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      setAddAdjustmentModalOpen(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Add An Adjustment
                  </Button>
                </>
              }
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Table
                    columns={adjustment_codes_columns}
                    scroll={{ x: 10 }}
                    dataSource={invoice?.adjustment_codes}
                    pagination={false}
                    summary={(pageData) => {
                      let rate_total = 0;
                      pageData.forEach(({ total }) => {
                        rate_total += total;
                      });
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell>Total:</Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                            <Table.Summary.Cell>{props.FormatNumberToCurrency(rate_total)}</Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  ></Table>
                </Col>
              </Row>
            </Card>
            <Card className="mt-2">
              {invoice ? (
                <>
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <Row gutter={[16, 16]}>
                        <Col span={10}>
                          <label className="col-form-label-sm">Invoice Number</label>
                          <Input type="text" style={{ textAlign: "center" }} value={invoice?.name ? "#" + invoice?.name : "Not yet saved"} className="form-control" readOnly />
                        </Col>
                        <Col span={10}>
                          <label className="col-form-label-sm">Out of Balance Figure</label>
                          <Tooltip
                            title={
                              <>
                                Time Entry Total - Line Items Total - Adjustments Total = Out of Balance Figure
                                <br />
                                {props.FormatNumberToCurrency(invoice.time_entry_total)} - {props.FormatNumberToCurrency(invoice.line_item_total)} -{" "}
                                {props.FormatNumberToCurrency(invoice.adjustments_total)} = {props.FormatNumberToCurrency(invoice.out_of_balance_figure)}
                              </>
                            }
                          >
                            <Input
                              type="text"
                              style={
                                invoice?.out_of_balance_figure
                                  ? invoice?.out_of_balance_figure === 0
                                    ? { textAlign: "center", backgroundColor: "#86BA90" }
                                    : { textAlign: "center", backgroundColor: "#E44E58" }
                                  : {}
                              }
                              value={props.FormatNumberToCurrency(invoice?.out_of_balance_figure)}
                              className="form-control"
                              readOnly
                            />
                          </Tooltip>
                        </Col>
                        <Col span={4}>
                          <label className="col-form-label-sm">Invoice Status</label>
                          <br />
                          {invoice?.status === 1 ? <Tag color="#108ee9">Proposed</Tag> : null}
                          {invoice?.status === 2 ? <Tag color="#87d068">Finalized</Tag> : null}
                          {invoice?.status === undefined ? <Tag className="bg-warning">Not Yet Saved</Tag> : null}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <label className="col-form-label-sm">&nbsp;</label>
                      <Dropdown
                        menu={{
                          items: save_menu_items,
                        }}
                        trigger={["click"]}
                      >
                        <Button type="primary" className="w-100">
                          <FontAwesomeIcon icon={faSave} className="mr-1" />
                          Save
                          <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                        </Button>
                      </Dropdown>
                    </Col>
                  </Row>
                </>
              ) : (
                <Skeleton />
              )}
            </Card>
          </Col>
        </Row>
        {/* Add Line Item Modal */}
        <Modal
          afterOpenChange={(open) => open && addLineItemFocusFirst.current?.focus()}
          title={selectedLineItem.updating ? "Update Line Item" : "Add A Line Item"}
          centered
          destroyOnClose={true}
          open={addLineItemModalOpen}
          onCancel={() => {
            setSelectedLineItem({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
            setAddLineItemModalOpen(false);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setSelectedLineItem({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
                  setAddLineItemModalOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  if (!selectedLineItem.item || !selectedLineItem.items_xref || isNaN(selectedLineItem.rate) || !selectedLineItem.quantity || isNaN(selectedLineItem.total))
                    return props.MakeNotification("warning", "Please fill out all the required fields.");
                  if (!selectedLineItem.updating) setInvoice({ ...invoice, line_items: [...invoice.line_items, { ...selectedLineItem, key: invoice.line_items.length }] });
                  if (selectedLineItem.updating)
                    setInvoice({
                      ...invoice,
                      line_items: invoice.line_items.map((m) => {
                        if (m.id && m.id === selectedLineItem.id) return { ...selectedLineItem, updating: false };
                        if (!m.id && m.key === selectedLineItem.key) return { ...selectedLineItem, updating: false };
                        return m;
                      }),
                    });
                  setSelectedLineItem({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
                  setAddLineItemModalOpen(false);
                }}
              >
                {selectedLineItem.updating ? "Update Line Item" : "Add A Line Item"}
              </Button>
            </>
          }
          width={modalWidth}
        >
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm">Item *</label>
              <Select
                ref={addLineItemFocusFirst}
                options={items}
                value={selectedLineItem.item}
                onChange={(e) => {
                  setSelectedLineItem({ ...selectedLineItem, item: e, items_xref: e.value, description: e.description, name: e.name, qbo_id: e?.qbo_id || null });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Rate *</label>
              <Input
                prefix="$"
                placeholder="0.00"
                value={selectedLineItem.rate}
                onChange={(e) => {
                  setSelectedLineItem({ ...selectedLineItem, rate: e.target.value, total: e.target.value * selectedLineItem.quantity });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Quantity *</label>
              <Input
                placeholder="1"
                value={selectedLineItem.quantity}
                onChange={(e) => {
                  setSelectedLineItem({ ...selectedLineItem, quantity: e.target.value, total: e.target.value * selectedLineItem.rate });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Total</label>
              <Input
                disabled
                readOnly
                prefix="$"
                placeholder="0.00"
                value={selectedLineItem.total}
                onChange={(e) => {
                  setSelectedLineItem({ ...selectedLineItem, total: e.target.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm">Description</label>
              <Input.TextArea
                rows="1"
                value={selectedLineItem.description}
                onChange={(e) => {
                  setSelectedLineItem({ ...selectedLineItem, description: e.target.value });
                }}
              />
            </Col>
          </Row>
        </Modal>
        <Modal
          afterOpenChange={(open) => open && addAdjustmentCodeFocusFirst.current?.focus()}
          title={selectedAdjustment.updating ? "Update Adjustment" : "Add An Adjustment"}
          centered
          destroyOnClose={true}
          open={addAdjustmentModalOpen}
          onCancel={() => {
            setSelectedAdjustment({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
            setAddAdjustmentModalOpen(false);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setSelectedAdjustment({ item: null, items_xref: null, description: "", rate: 0, quantity: 1, total: 0 });
                  setAddAdjustmentModalOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  if (
                    !selectedAdjustment.adjustment ||
                    !selectedAdjustment.adjustment_codes_xref ||
                    !selectedAdjustment.user ||
                    !selectedAdjustment.adjustment_by ||
                    !selectedAdjustment.item ||
                    !selectedAdjustment.items_xref ||
                    !selectedAdjustment.rate ||
                    !selectedAdjustment.quantity ||
                    !selectedAdjustment.total
                  )
                    return props.MakeNotification("warning", "Please fill out all the required fields.");
                  if (!selectedAdjustment.updating) setInvoice({ ...invoice, adjustment_codes: [...invoice.adjustment_codes, { ...selectedAdjustment, key: invoice.adjustment_codes.length }] });
                  if (selectedAdjustment.updating)
                    setInvoice({
                      ...invoice,
                      adjustment_codes: invoice.adjustment_codes.map((m) => {
                        if (m.id && m.id === selectedAdjustment.id) return { ...selectedAdjustment, updating: false };
                        if (!m.id && m.key === selectedAdjustment.key) return { ...selectedAdjustment, updating: false };
                        return m;
                      }),
                    });
                  setSelectedAdjustment({
                    user: null,
                    adjustment_by: null,
                    adjustment: null,
                    adjustment_codes_xref: null,
                    item: null,
                    items_xref: null,
                    description: "",
                    rate: 0,
                    quantity: 1,
                    total: 0,
                  });
                  setAddAdjustmentModalOpen(false);
                }}
              >
                {selectedAdjustment.updating ? "Update Adjustment" : "Add Adjustment"}
              </Button>
            </>
          }
          width={modalWidth}
        >
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm">Adjustment Code *</label>
              <Select
                ref={addAdjustmentCodeFocusFirst}
                options={adjustmentCodes.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0))}
                value={selectedAdjustment.adjustment}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, adjustment: e, adjustment_codes_xref: e.value, name: e.name, discount: e.discount });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">User *</label>
              <Select
                options={props.MakeUserOptions(users)}
                value={selectedAdjustment.user}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, user: e, adjustment_by: e.value, users_name: e.label });
                }}
              />
            </Col>
            <Col span={12}></Col>
            <Col span={6}>
              <label className="col-form-label-sm">Item *</label>
              <Select
                options={[
                  {
                    label: "Suggested",
                    options: [
                      ...new Set(
                        invoice?.time_entries?.map((obj) => {
                          return obj.items_xref;
                        }),
                      ),
                    ].map((m, index) => {
                      return { ...items.find((f) => f.id === m), key: "suggested-" + index };
                    }),
                  },
                  {
                    label: "Full List",
                    options: items,
                  },
                ]}
                value={selectedAdjustment.item}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, item: e, items_xref: e.value, items_name: e.label });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Rate *</label>
              <Input
                prefix="$"
                placeholder="0.00"
                value={selectedAdjustment.rate}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, rate: e.target.value, total: e.target.value * selectedAdjustment.quantity * (selectedAdjustment.discount ? -1 : 1) });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Quantity *</label>
              <Input
                placeholder="1"
                value={selectedAdjustment.quantity}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, quantity: e.target.value, total: e.target.value * selectedAdjustment.rate * (selectedAdjustment.discount ? -1 : 1) });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Total</label>
              <Input
                readOnly
                disabled
                prefix="$"
                placeholder="0.00"
                value={selectedAdjustment.total}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, total: e.target.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm">Description</label>
              <Input.TextArea
                rows="1"
                value={selectedAdjustment.description}
                onChange={(e) => {
                  setSelectedAdjustment({ ...selectedAdjustment, description: e.target.value });
                }}
              />
            </Col>
          </Row>
        </Modal>
      </div>
    </main>
  );
}

export default Invoicing;
